import type { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { keepPreviousData } from '@tanstack/react-query';
import { isEmpty } from 'lodash-es';
import { api } from '../../../utils/api.ts';
import { useQuoteOrderListFilters } from './use-quote-order-list-filters.tsx';

export function useQuoteOrderListSummary(orderType: SrSalesOrderType) {
    const [appliedFilters] = useQuoteOrderListFilters(orderType);

    const hasRealFilters = !isEmpty(appliedFilters.entryDateRange);

    const { data, isLoading } = api.platoUser.getManyQuotesOrders.getAggregates.useQuery(
        {
            ...appliedFilters,
            orderTypes: [orderType],
            orderStatus: appliedFilters.orderStatus as SrOrderStatus[],
        },
        { enabled: hasRealFilters, placeholderData: hasRealFilters ? keepPreviousData : undefined },
    );

    if (isLoading || !data || !hasRealFilters) {
        return {};
    }

    return {
        summary: {
            total_amount_net: data.totalAmountNet,
            total_margin: data.totalMargin,
        },
    };
}
